var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatisthis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.01502 1.70086C8.4215 1.70086 9.77029 2.25954 10.765 3.25412C11.7594 4.24858 12.3182 5.59739 12.3182 7.00383C12.3182 8.41027 11.7594 9.75914 10.765 10.7535C9.77042 11.7481 8.42163 12.3068 7.01502 12.3068C5.60867 12.3068 4.25976 11.7481 3.26538 10.7535C2.27081 9.75908 1.71215 8.41027 1.71215 7.00383C1.71215 5.59739 2.27081 4.24851 3.26538 3.25412C4.25982 2.25954 5.60874 1.70086 7.01502 1.70086ZM7.01502 1.00014V1.00002C5.82795 0.997101 4.6666 1.34625 3.67804 2.0036C2.68945 2.66094 1.91796 3.59666 1.4615 4.69258C1.00495 5.7885 0.883683 6.99513 1.11313 8.15981C1.34268 9.3246 1.9125 10.3952 2.75071 11.2359C3.58875 12.0767 4.65751 12.65 5.82153 12.8831C6.98554 13.1163 8.19264 12.9989 9.29 12.5459C10.3873 12.0927 11.3255 11.3243 11.9859 10.3378C12.6463 9.35119 12.9993 8.19098 13 7.00367C12.998 5.41554 12.3673 3.89287 11.2458 2.76857C10.1242 1.64428 8.60322 1.00973 7.01528 1.00365L7.01502 1.00014Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99799 10.2306C6.74454 10.2306 6.53906 10.0734 6.53906 9.8795V5.96825C6.53906 5.77328 6.74573 5.61523 7.00052 5.61523C7.25547 5.61523 7.46214 5.77328 7.46214 5.96825V9.8795C7.46214 9.97328 7.41302 10.0631 7.32597 10.1292C7.23876 10.1951 7.12062 10.2316 6.99799 10.2306Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46214 4.23083C7.46214 4.48571 7.25549 4.69236 7.0006 4.69236C6.74571 4.69236 6.53906 4.48572 6.53906 4.23083C6.53906 3.97593 6.74571 3.76929 7.0006 3.76929C7.25549 3.76929 7.46214 3.97593 7.46214 4.23083Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatisthis);
export default __webpack_public_path__ + "static/media/whatisthis.c8b8542f45499e654dd5262d12ed8a14.svg";
export { ForwardRef as ReactComponent };